import React, { useState } from "react"; // Removed useEffect as it's no longer needed for userName fallback
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Chat from "./Chat"; // Your existing Chat component

const ChatPage = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Get userName from navigate state if passed, else fallback
  const [userName] = useState(location.state?.userName || `User ${userId}`); // Fallback directly here

  return (
    <div style={{ padding: "1rem" }}>
      <button onClick={() => navigate(-1)} style={{ marginBottom: "1rem" }}>
        ← Back
      </button>
      <h2>Chat with {userName}</h2>
      <Chat
        selectedUserId={userId}
        selectedUserName={userName}
        onBack={() => navigate(-1)} // Pass onBack prop
      />
    </div>
  );
};

export default ChatPage;